import request from '@/utils/request'

// 科目余额
export function printSetOne(data) {
  return request({
    url: 'api/v2/printSet/one',
    method: 'post',
    data
  })
}
// 科目余额打印
export function accountBook(data) {
  return request({
    url: 'api/v2/print/accountBook',
    method: 'post',
    data
  })
}

// 导出
export function exportBook(data) {
  return request({
    url: 'api/v2/export/accountBook',
    method: 'post',
    data
  })
}
// 税表打印
export function report(data) {
  return request({
    url: 'api/v2/print/report',
    method: 'post',
    data
  })
}

// 税表导出
export function exportReport(data) {
  return request({
    url: 'api/v2/export/report',
    method: 'post',
    data
  })
}

// 工资表打印
export function printSalary(data) {
  return request({
    url: 'api/v2/print/salary',
    method: 'post',
    data
  })
}

// 记账客户导出
export function assignCustomers(data) {
  return request({
    url: 'api/v2/export/assignCustomers',
    method: 'post',
    data
  })
}
